var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme, TRANSITION } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { useLang } from '../hooks/use-lang';
import { OnboardingButton } from '../elements/onboarding-button';
import { ContentEntityRichTitle } from './content-entity-rich-title';
import { ContentNode } from './content-node';
var cls = classNames('slice-onboarding-section');
export var SliceOnboardingSectionDefaultProps = {
  pretitle: 'Let’s tailor your experience'
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-size: ", ";\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  "], ["\n    font-size: ", ";\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  "])), theme.FONT_SIZE(16))
});
var TitlesStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-size: ", ";\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: ", ";\n  "], ["\n    font-size: ", ";\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: ", ";\n  "])), theme.FONT_SIZE(16), theme.UNIT(4))
});
var PretitleStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin: 0;\n    font-weight: 300;\n    text-align: center;\n    font-size: 1em;\n  "], ["\n    margin: 0;\n    font-weight: 300;\n    text-align: center;\n    font-size: 1em;\n  "])))
});
var TitleStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin: 0;\n    font-weight: 300;\n    text-align: center;\n    font-family: ", ";\n    font-size: ", "em;\n\n    strong {\n      color: ", ";\n    }\n  "], ["\n    margin: 0;\n    font-weight: 300;\n    text-align: center;\n    font-family: ", ";\n    font-size: ", "em;\n\n    strong {\n      color: ", ";\n    }\n  "])), theme.FONT('serif'), 32 / 16, theme.COLOR('primary'))
});
var RichPretitleStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var RichTitleStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    ", "\n    line-height: 1.1em;\n  "], ["\n    ", "\n    line-height: 1.1em;\n  "])), TitleStyles)
});
var ButtonsStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    width: 100%;\n    font-family: ", ";\n  "], ["\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    width: 100%;\n    font-family: ", ";\n  "])), theme.FONT('sans'))
});
var ContinueStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    &:hover {\n      filter: brightness(1.05);\n      ", "\n    }\n  "], ["\n    &:hover {\n      filter: brightness(1.05);\n      ", "\n    }\n  "])), TRANSITION('filter'))
});
var PreviousButtonStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n\n  "], ["\n\n  "])))
});
// -------- Components -------->
var My = {
  NAME: 'SliceOnboardingSection',
  Container: styled.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Titles: styled.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), TitlesStyles),
  Pretitle: styled.h3(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), PretitleStyles),
  Title: styled.h1(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  RichTitle: styled(ContentEntityRichTitle)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), RichTitleStyles),
  RichPretitle: styled(ContentNode)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), RichPretitleStyles),
  Buttons: styled.div(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), ButtonsStyles),
  ContinueButton: styled(OnboardingButton)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), ContinueStyles),
  PreviousButton: styled(OnboardingButton)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), PreviousButtonStyles)
};
export var SliceOnboardingSection = function (props) {
  var _a = useComponentProps(My.NAME, props, SliceOnboardingSectionDefaultProps),
    className = _a.className,
    children = _a.children,
    entity = _a.entity,
    title = _a.title,
    pretitle = _a.pretitle;
  var _b = entity || {},
    sliceTitle = _b.title,
    slicePretitle = _b.pretitle,
    titleRich = _b.titleRich,
    pretitleRich = _b.pretitleRich;
  var hasTitle = !!(titleRich === null || titleRich === void 0 ? void 0 : titleRich.text) || !!sliceTitle;
  var hasRichPretitle = !!(pretitleRich === null || pretitleRich === void 0 ? void 0 : pretitleRich.text);
  // if (!title && !pretitle) {
  //     return null;
  // }
  var t = useLang();
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Titles, null, hasRichPretitle ? React.createElement(My.RichPretitle, {
    entity: pretitleRich
  }) : React.createElement(My.Pretitle, {
    dangerouslySetInnerHTML: {
      __html: t(slicePretitle || pretitle)
    }
  }), hasTitle ? React.createElement(My.RichTitle, {
    entity: entity
  }) : React.createElement(My.Title, {
    dangerouslySetInnerHTML: {
      __html: t(title)
    }
  })), children);
};
SliceOnboardingSection.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18;